import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoadingSpinner from 'Components/shared/LoadingSpinner';
import Urls from 'Utils/urls';

const instance = axios.create();
instance.defaults.headers.common = {};

const PrivacyPolicy = () => {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    const loadPrivacyPolicy = async () => {
      try {
        const { data } = await instance.get(`${Urls.get()?.blob}/PrivacyPolicy.html`);
        if (data) {
          setHtml(data);
        }
      } catch (error) {
      }
    };
    loadPrivacyPolicy();
  }, []);

  return html ? (
    <div className="revertPageContainer px-16 md:px-0">
      <div
        style={{ minHeight: '100%' }}
        dangerouslySetInnerHTML={{ __html: html }}
      ></div>
    </div>
  ) : (
    <div className="w-full h-full flex items-center justify-center">
      <LoadingSpinner />
    </div>
  );
};

export default PrivacyPolicy;
